import React from "react";
import { FaMobileAlt, FaUsers, FaTools, FaHeadset } from "react-icons/fa";

import "./Stats.css";

function Stats() {
  const stats = [
    {
      icon: <FaMobileAlt />,
      number: "5000+",
      label: "Devices Repaired",
      animation: "zoom-in",
    },
    {
      icon: <FaUsers />,
      number: "1000+",
      label: "Happy Customers",
      animation: "zoom-in",
    },
    {
      icon: <FaTools />,
      number: "5+",
      label: "Years Experience",
      animation: "zoom-in",
    },
    {
      icon: <FaHeadset />,
      number: "24/7",
      label: "Customer Support",
      animation: "zoom-in",
    },
  ];

  return (
    <section className="stats-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Our Achievements</span>

          <h2 className="section-title">Trusted By Customers Across UAE</h2>

          <p className="section-description">
            We take pride in delivering quality mobile repair services with a
            focus on customer satisfaction.
          </p>
        </div>

        <div className="row">
          {stats.map((stat, index) => (
            <div
              className="col-lg-3 col-md-6 col-6 mb-3"
              key={index}
              data-aos={stat.animation}
              data-aos-delay={index * 150}
            >
              <div className="stat-card">
                <div className="stat-icon">{stat.icon}</div>

                <h3>{stat.number}</h3>

                <p>{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
